import { connect } from 'react-redux'
import { getCategory } from '../../actions/CategoryActions'
import { CATEGORIES } from '../../constants/ContentConstants'

import ViewContent from '../ViewContent'

const mapStateToProps = state => {
  return {
    type: CATEGORIES,
    content: state.categories.current
  }
}

const mapDispatchToProps = dispatch => ({
  getContent: payload => dispatch(getCategory(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(ViewContent)
